export const JOURNEYS = {
  ONLINE_REGISTRATION: {
    Journey: {
      Name: 'O4BRegistration',
      Version: '1.0',
    },
    Brand: (window as any)?.appConfig?.BRAND_NAME === 'bos' ? 'BOS' : 'Lloyds',
    Division: 'Commercial',
    Presentation: 'Responsive',
    Product: {
      Location1: 'Online Banking',
      Location2: 'Online for business',
    },
    Channel: {
      Location: 'Online',
      SortCode: undefined,
      FileId: undefined,
      CustomerAuth: false,
    },
    PageRole: 'Servicing',
    JourneyProduct: {
      Product1: 'Online',
      Product2: undefined,
      Product3: undefined,
    },
    ApplicationId: '',
  },
};

export const JOURNEY_STEPS = {
  ONLINE_REGISTRATION: {
    TRIAGE_START_PAGE: {
      JourneyStepName: 'Register for Online for Business',
      JourneyAction: 'Application Processing',
      JourneyActionNarrative: 'Start page',
      JourneyProduct: 'Online for business',
      JourneyStep: '1',
      ApplicationState: 'Pre-Application',
    },
    FULL_SIGNATORY_VERIFICATION: {
      JourneyStepName: 'Full signatory on Bank Mandate',
      JourneyAction: 'Application Processing',
      JourneyActionNarrative: 'Full signatory',
      JourneyProduct: ' Online for business',
      JourneyStep: '2',
      ApplicationState: 'Pre-Application',
    },
    THREE_STEPS_TO_REGISTER: {
      JourneyStepName: 'Three steps to register',
      JourneyAction: 'More information needed',
      JourneyActionNarrative: 'Delegate access user',
      JourneyProduct: 'Online for business',
      JourneyStep: '3',
      ApplicationState: 'Pre-Application',
    },
    THREE_STEPS_TO_REGISTER_APPROVAL: {
      JourneyStepName: 'Approve your registration',
      JourneyAction: 'Application Processing',
      JourneyActionNarrative: 'Approval for registration',
      JourneyProduct: 'Online for business',
      JourneyStep: '4',
      ApplicationState: 'Pre-Application',
    },
    THREE_STEPS_TO_REGISTER_MORE_APPROVER: {
      JourneyStepName: 'Approve your registration',
      JourneyAction: 'More information needed',
      JourneyActionNarrative: ' More approvers needed',
      JourneyProduct: 'Online for business',
      JourneyStep: '5',
      ApplicationState: 'Pre-Application',
    },
    ABOUT_THE_BUSINESS: {
      JourneyStepName: 'About the business',
      JourneyAction: 'Application Processing',
      JourneyActionNarrative: 'About the business',
      JourneyProduct: 'Online for business',
      JourneyStep: '6',
      ApplicationState: 'Application',
    },
    ABOUT_THE_BUSINESS_ERROR: {
      JourneyStepName: 'About the business error',
      JourneyAction: 'Error',
      JourneyActionNarrative: 'Error - No match or open account',
      JourneyProduct: 'Online for business',
      JourneyStep: '6',
      ApplicationState: 'Referred',
    },
    ABOUT_THE_BUSINESS_ERROR_HOCA: {
      JourneyStepName: 'About the business error HOCA',
      JourneyAction: 'Customer Ineligible',
      JourneyActionNarrative: 'Error- HOCA',
      JourneyProduct: ' Online for business',
      JourneyStep: '6',
      ApplicationState: 'Declined',
    },
    ABOUT_THE_BUSINESS_MAYFAIR_ACCOUNT_ERROR: {
      JourneyStepName: 'About the business error',
      JourneyAction: 'Customer Ineligible',
      JourneyActionNarrative: 'Error - Mayfair account holder',
      JourneyProduct: 'Online for business',
      JourneyStep: '6',
      ApplicationState: 'Declined',
    },
    ABOUT_YOU: {
      JourneyStepName: 'About you',
      JourneyAction: 'Application Processing',
      JourneyActionNarrative: 'About you',
      JourneyProduct: 'Online for business',
      JourneyStep: '7',
      ApplicationState: 'Application',
    },
    ABOUT_YOU_ERROR: {
      JourneyStepName: 'About you error',
      JourneyAction: 'Error',
      JourneyActionNarrative: 'No OCIS match',
      JourneyProduct: 'Online for business',
      JourneyStep: '7',
      ApplicationState: 'Referred',
    },
    ABOUT_YOU_ERROR_AGE_VERIFICATION_FAILURE: {
      JourneyStepName: 'About you error aged 17 or under',
      JourneyAction: 'Error',
      JourneyActionNarrative:
        'You must be 18 or over to register for Business Internet Banking',
      JourneyProduct: 'Online for business',
      JourneyStep: '7',
      ApplicationState: 'Declined',
    },
    PLEASE_CALL_US: {
      JourneyStepName: 'Please call us',
      JourneyAction: 'Error',
      JourneyActionNarrative: '',
      JourneyProduct: 'Online for business',
      JourneyStep: '8',
      ApplicationState: 'Referred',
    },
    ALREADY_REGISTERED: {
      JourneyStepName: "You've already registered",
      JourneyAction: 'Customer Ineligible',
      JourneyActionNarrative: 'Customer already registered',
      JourneyProduct: 'Online for business',
      JourneyStep: '9',
      ApplicationState: 'Declined',
    },
    REGISTRATION_IN_PROGRESS: {
      JourneyStepName: 'Registration is already in progress',
      JourneyAction: 'Error',
      JourneyActionNarrative: 'Duplicate application',
      JourneyProduct: 'Online for business',
      JourneyStep: '10',
      ApplicationState: 'Declined',
    },
    THANK_YOU: {
      JourneyStepName: 'Thank you',
      JourneyAction: 'Product Opened',
      JourneyActionNarrative: 'Request to register for online for business',
      JourneyProduct: 'Online for business',
      JourneyStep: '12',
      ApplicationState: 'Fulfiled',
    },
    MOBILE_NUMBER_MISSING: {
      JourneyStepName: "Don't have a mobile number",
      JourneyAction: 'Error',
      JourneyActionNarrative: 'No mobile number',
      JourneyProduct: 'Online for business',
      JourneyStep: '11',
      ApplicationState: 'Referred',
    },
  },
  GENERIC: {
    TIMEOUT: {
      JourneyStepName: 'Session timeout',
      JourneyAction: 'Error',
      JourneyActionNarrative: 'Error - Session timeout',
      JourneyProduct: 'Online for business',
      JourneyStep: '',
      ApplicationState: 'Referred',
    },
  },
};

export const BUTTON_EVENTS = {
  PREVIOUS: { JourneyEvent: 'Button Click', LinkValue: 'button/previous' },
};

export const LINK_EVENT = {
  FILL_REGISTRATION_FORM: {
    JourneyEvent: 'External Click',
    EventAction: 'Supporting Material',
    EventNarrative: 'Fill out the registration form',
  },
  OPEN_TERMS_AND_CONDITIONS: {
    JourneyEvent: 'External Click',
    EventAction: 'Supporting Material',
    EventNarrative: 'Terms and conditions',
  },
  FILL_FORM: {
    JourneyEvent: 'External Click',
    EventAction: 'Supporting Material',
    EventNarrative: 'Fill out this form',
  },
  RESET_THEM_ONLINE: {
    JourneyEvent: 'External Click',
    EventAction: 'Supporting Material',
    EventNarrative: 'Reset them online',
  },
};

export const ACCORDION_EVENTS = {
  FULL_SIGNATORY_CHECK: "How do I know if I'm a full signatory",
  BANK_MANDATE_INSTRUCTIONS: 'What is a bank mandate and signing instructions?',
  INSIDE_BANK_MANDATE: "How can I find out what's on the bank mandate?",
  CONTACT_US: 'Contact us',
  FULL_ACCESS_USER_PERMISSIONS: 'What can a full access user do?',
};

export const JOURNEY_EVENT = {
  BUTTON_CLICK: 'Button Click',
  EXTERNAL_LINK: 'External Click',
  INTERNAL_CLICK: 'Internal Click',
  CLICK_TO_CALL: 'Click to Call',
};

export const EVENT_ACTION = {
  SUPPORTING_MATERIAL: 'Supporting Material',
  CLICK_TO_CALL: 'Click to Call',
  AGREE_TO_TERMS_AND_CONDITIONS: 'Agree to T&Cs',
};
